<template>
  <el-container class="homepage">
    <el-aside style="background-color: rgb(238, 241, 246);box-shadow: 2px 0 6px rgb(0 21 41 / 35%)"
              width="auto !important">
      <div class="menu_title">鸣物联-管理</div>
      <el-menu :collapse="isCollapse"
               :default-active="this.$route.path"
               active-text-color="#387ddd"
               class="aside_menu"
               @close="handleClose"
               @open="handleOpen">
        <div v-for="(item, index) in menuList"
             :key="'menu' + index">

          <el-menu-item v-if="!item.children"
                        :index="item.page"
                        @click="jumpRouter(item)">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>

          <el-submenu v-if="item.children"
                      :index="item.title">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item v-for="(childItem, childIndex) in item.children"
                          :key="'submenu' + childIndex"
                          :index="childItem.page"
                          @click="jumpRouter(childItem)"><i :class="childItem.icon"></i>
              <span slot="title">{{ childItem.title }}</span>
            </el-menu-item>
          </el-submenu>

        </div>
      </el-menu>

    </el-aside>

    <el-container>
      <el-header class="header">
        <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
           style="margin: 0 5px;font-size: 26px"
           @click="isCollapse ? isCollapse = false : isCollapse = true"></i>
        <div>
          <span>{{ userInfo.userName }}</span>
          <el-dropdown trigger="click"
                       @command="handleCommand">
            <i class="el-icon-arrow-down"
               style="margin: 0 5px;font-size: 15px;color: #fff;"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">个人信息</el-dropdown-item>
              <el-dropdown-item command="b">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main>
        <router-view/>
      </el-main>
    </el-container>

    <!-- 个人信息 -->
    <el-dialog :before-close="cancelUserInfoDialog"
               :visible.sync="userInfoDialog"
               title="个人信息"
               width="40%">
      <el-form ref="userInfoForm"
               :model="userInfoForm"
               :rules="userInfoRule"
               class="userInfoForm"
               label-width="40%">
        <el-form-item label="用户名"
                      prop="userName">
          <el-input v-model="userInfoForm.userName"
                    disabled
                    placeholder="用户名"
                    style="width: 200px;"
                    @keyup.enter.native="userInfoHandle()"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="phone">
          <el-input v-model="userInfoForm.userPhone"
                    disabled
                    placeholder="手机号"
                    style="width: 200px;"
                    @keyup.enter.native="userInfoHandle()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelUserInfoDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="userInfoHandle()">确 定</el-button>
      </span>
    </el-dialog>

  </el-container>
</template>

<script>
import '../assets/css/homepage.css'

export default {
  data() {
    return {
      userInfo: {},
      isCollapse: false,
      menuList: [
        // {
        //   page: '/homepage/home',
        //   title: '首页',
        //   icon: 'el-icon-s-data',
        // },
        {
          page: '/homepage/ApartmentManagement',
          title: '公寓管理',
          icon: 'el-icon-office-building',
        },
        {
          page: '/homepage/RoomManagement',
          title: '房间管理',
          icon: 'el-icon-s-home',
        },
        {
          page: '/homepage/JanitorManagement',
          title: '管理员管理',
          icon: 'el-icon-s-check',
        },
        {
          page: '/homepage/AppRoleList',
          title: '管理者权限',
          icon: 'el-icon-coordinate',
        }
        /*{
          page: '/homepage/DeviceManagement',
          title: '设备管理',
          icon: 'el-icon-s-cooperation',
        },
        {
          page: '/homepage/ProductManagement',
          title: '产品管理',
          icon: 'el-icon-s-cooperation',
        },
        {
          page: '/homepage/FirmwareManagement',
          title: '升级管理',
          icon: 'el-icon-s-cooperation',
        },
        {
          page: '/homepage/UserManagement',
          title: '人员管理',
          icon: 'el-icon-user',
        },
        {
          title: '统计管理',
          icon: 'el-icon-s-data',
          children: [
            {
              page: '/homepage/UnlockRecord',
              title: '开锁记录',
              icon: 'el-icon-unlock',
            },
            {
              page: '/homepage/OperationRecord',
              title: '操作记录',
              icon: 'el-icon-notebook-2',
            },
          ],
        },*/
      ],
      userInfoDialog: false,
      userInfoForm: {},
      userInfoRule: {
        userName: [
          {required: true, message: '用户名不能为空', trigger: 'blur'},
        ],
        phone: [{required: true, message: '手机号不能为空', trigger: 'blur'}],
      },
    }
  },

  computed: {},

  created() {
    let self = this

    if (sessionStorage.getItem('userInfo')) {
      self.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      self.userInfoForm = self.userInfo
    }

    if(self.userInfo.platformPermission == 1){
      let ota = {
        title: 'OTA升级',
        icon: 'el-icon-refresh-right',
        children: [
          {
            page: '/homepage/OtaBinManagement',
            title: 'bin版本',
            icon: 'el-icon-document-checked',
          },
          {
            page: '/homepage/OtaTaskManagement',
            title: 'OTA任务',
            icon: 'el-icon-notebook-2',
          },
        ],
      }

      self.menuList.push(ota)
    }
  },

  mounted() {
  },

  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },

    // 跳转路由
    jumpRouter: function (item) {
      let self = this

      if (item.page != self.$route.path) {
        self.$router.push({
          path: item.page,
          query: {},
        })
      }
    },

    // 个人菜单操作
    handleCommand(command) {
      let self = this

      if (command == 'a') {
        // 个人信息
        self.openUserInfoDialog()
      } else if (command == 'b') {
        // 退出登录
        self.outLogin()
      }
    },

    // 打开 个人信息弹窗
    openUserInfoDialog: function () {
      let self = this

      self.userInfoDialog = true
    },

    // 修改个人信息
    userInfoHandle: function () {
      let self = this

      self.cancelUserInfoDialog
    },

    // 关闭 个人信息弹窗
    cancelUserInfoDialog: function () {
      let self = this

      // Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.userInfoDialog = false
    },

    // 退出登录
    outLogin: function () {
      let self = this

      self.$router.push({
        path: '/login',
        query: {},
      })

      sessionStorage.clear()
    },
  },
}
</script>

<style>
.el-header {
  background-color: #387ddd;
  color: #fff;
  line-height: 60px;
}

.el-menu--collapse .el-submenu__title span {
  display: none;
}

.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/homepage.vue